<template>
  <b-modal
    no-close-on-backdrop
    centered
    ok-only
    size="lg"
    ok-title="Fechar"
    ok-variant="danger"
    v-model="open"
    :title="`Detalhes do profissional ${professionalId}`"
    :busy="loading"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="6">
        <Info
          label="Foto principal"
          :value="fields.profilePicture ? '' : 'Sem foto'"
        />
        <b-img
          v-if="fields.profilePicture"
          fluid
          :src="getImagesAddress + fields.profilePicture"
        ></b-img>
      </b-col>
      <b-col cols="6">
        <Info label="Número do profissional" :value="professionalId" />
      </b-col>
      <b-col cols="6">
        <Info label="Nome do cliente" :value="fields.name" />
      </b-col>
      <b-col cols="6" class="mt-4">
        <Info label="Nome da empresa" :value="fields.companyName || 'N/A'" />
      </b-col>
      <b-col cols="6" class="mt-4">
        <Info label="Nome da fantasia" :value="fields.fantasyName || 'N/A'" />
      </b-col>
      <b-col cols="6" class="mt-4" v-if="PROFESSIONAL_TYPES.LEGAL">
        <Info label="CNPJ" :value="fields.cnpj || 'N/A'" />
      </b-col>
      <b-col cols="6" class="mt-4" v-if="PROFESSIONAL_TYPES.PHYSICAL">
        <Info label="RG" :value="fields.rg || 'N/A'" />
      </b-col>
      <b-col cols="6" class="mt-4" v-if="PROFESSIONAL_TYPES.PHYSICAL">
        <Info label="CPF" :value="fields.cpf || 'N/A'" />
      </b-col>
      <b-col cols="6" class="mt-4">
        <Info label="Endereço" :value="fields.address || 'N/A'" />
      </b-col>
      <b-col cols="6" class="mt-4">
        <Info label="Celular" :value="fields.cellphone || 'N/A'" />
      </b-col>
      <b-col cols="12" md="6" class="mt-4">
        <Info label="E-mail" :value="fields.email || 'N/A'" />
      </b-col>
      <b-col cols="6" class="mt-4">
        <Info label="Criado em" :value="fields.createdAt" />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import makeToast from '@/mixins/makeToast';

import PROFESSIONAL_TYPES from 'Enums/Professional/ProfessionalTypes.js';

import Info from './Info.vue';

export default {
  name: 'ProfessionalDetails',
  mixins: [makeToast],
  data() {
    return {
      PROFESSIONAL_TYPES,
      loading: false,
      professionalId: 0,
      open: false,
      fields: this.defaultProfessionalDetails(),
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddress']),
  },
  methods: {
    ...mapActions('shopkeeper', ['getProfessional']),
    toggleOpen({ professionalId = 0 }) {
      this.clean();

      this.open = !this.open;
      this.professionalId = professionalId;

      this.get();
    },
    get() {
      if (this.loading || !this.professionalId) return;

      this.loading = true;

      this.getProfessional({
        professionalId: this.professionalId,
        userId: this.dadosUsuario.id,
      })
        .then((response) => {
          this.fields = response.data.data || {};
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados do pedido',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clean() {
      this.professionalId = 0;
      this.fields = this.defaultProfessionalDetails();
    },
    defaultProfessionalDetails() {
      return {
        id: '',
        type: '',
        name: '',
        fantasyName: '',
        companyName: '',
        cnpj: '',
        cpf: '',
        rg: '',
        profilePicture: '',
        servicesIds: '',
        works: [],
        address: '',
        telephone: '',
        email: '',
        createdAt: '',
        updatedAt: '',
      };
    },
    getType(type) {
      const texts = {
        credit_card: 'Cartão de crédito',
      };

      return texts[type] || 'N/A';
    },
  },
  components: {
    Info,
  },
};
</script>
